define('AddressAutocompleteView',['jquery', 'underscore', 'backbone', 'app', 'hooks', 'site_vars', 'moment', 'SubView', 'SelectView',
        'TagCommander',
        'models/AddressAutocompleteCollection',
        'models/AddressAutocompleteModel',
        'PlaceModel',
        'Geolocation',
        'models/EstimatedTimeModel',
        'template!blocks/address-autocomplete',
        'template!blocks/address-autocomplete-input',
        'template!blocks/address-autocomplete-line',
        'views/ui/AutocompleteLineView',
        'views/blocks/AddressAutocompleteFallbackView',
        'InputView',
        'momentFormats'
    ],
    function ($, _, backbone, app, hooks, site_vars, moment, SubView, SelectView,
              TagCommander,
              AddressAutocompleteCollection,
              AddressAutocompleteModel,
              PlaceModel,
              Geolocation,
              EstimatedTimeModel,
              addressAutocompleteTemplate,
              addressAutocompleteInputTemplate,
              addressAutocompleteLineTemplate,
              AutocompleteLineView,
              AddressAutocompleteFallbackView,
              InputView,
              momentFormats
    ) {

        var cleanSushishop = /sushi ?shop/gi,
            TranslationContext = 'AddressAutocomplete',
            max = Math.max, min = Math.min,
            LINE_COUNT_MAX = 6, // nombre de ligne maximum
            LINE_STORE_ADDRESS_MEDIUM = 3 // ligne médiane;

        function alertGeolocateError(){
            app.off('geolocation_error',alertGeolocateError);
            app.alert({
                title:app.t('Erreur','UI'),
                subtitle:app.t('Impossible de vous localiser, veuillez vérifier que cette fonctionnalité est active sur votre navigateur.',TranslationContext)
            });
        }

        return backbone.View.extend(SubView).extend({
            events: {
                'keyup input:text': 'keyup',
                'focusin input:text': 'focusin',
                'focusout': 'focusout',
                'submit form': 'submitForm',
                'click .btn-close': 'clickClose',
                'click .overlay': 'clickClose',
                'click .geolocate': 'geolocate',
                'change .autocomplete-filters :radio': 'changeFilter',
                'click .autocomplete-filters': 'toggleComeInTooltip',
            },
            isFallbackVisible:false,
            initialize: function (options) {

                var view = this;
                view.subviews = [];

                view.resultsView = [];

                //
                view.started = false;
                view.el.view = view;
                view.selectedIndex = -1;

                function setDefaultOption(key, defaultValue){
                    var v = !_.isUndefined(options[key]) ? options[key] : defaultValue;
                    view[key] = v;
                }

                // fetching Mode
                setDefaultOption('fetchingPlace', app.c('_ADDRESS_AUTOCOMPLETE_PLACE_FETCHING_','no')); // yes | no
                //
                setDefaultOption('cart', app.getCart());                // référence panier
                setDefaultOption('initialInput', '');                   // champs texte affiché initialement
                setDefaultOption('initialAddress', false);              // selection d'une adresse
                setDefaultOption('initialStore', false);                // selection d'une boutique
                setDefaultOption('ignoreAddressPreset', false);         // ignore la préselection de l'adresse du client
                setDefaultOption('theme', 'default');                   // popin | form-field | default
                setDefaultOption('type', 'all');                        // all | address | store
                setDefaultOption('action', 'cart');                     // cart | customer
                setDefaultOption('action_context', 'default');          // default | add
                setDefaultOption('displayDelay', view.usePlaceFetch()); // Boolean / cherche à afficher le délai
                setDefaultOption('displayFilters', view.type == 'all'); // Boolean / affiche les filtres
                setDefaultOption('autoSubmit', true);                   // Boolean / effectue l'action submit au clic
                setDefaultOption('style', '');                          // String
                setDefaultOption('description', false);                 // String | false affiche un bloc de texte
                setDefaultOption('ignoreInitialSelection', false);      // Supprime la sélection
                setDefaultOption('mode',app.c('_ADDRESS_AUTOCOMPLETE_MODE_','default')); // Mode d'autocomplete : normal | manual
                setDefaultOption('preorder_product', false);                            // Produit en précommande requirant une boutique

                var cart = view.cart,
                    store,address;

                if(view.displayFilters && view.type == 'all'){
                    // si on active les filtres, on bascule automatiquement de type all à type address
                    view.type = cart.validateDeliveryOptions() && cart.isVAE() ? 'store' : 'address';
                }

                // autoSubmit sert à éviter un clic sur le bouton Rechercher

                view.$el.addClass('theme-' + view.theme);

                //
                if(view.action == 'cart'){
                    //
                    // si on est sur une association panier
                    //
                    if(cart.isVAE() && view.type!='address'){
                        // si on a une boutique selectionnée, on preset la boutique
                        store = cart.getStore();
                        if(store){
                            view.initialStore = store;
                        }
                    }else if(view.type!='store'){
                        // si on a une adresse selectionnée
                        address = cart.getAddressDelivery();
                        var place = cart.getPlace();
                        //
                        if(!address && cart.getDeliveryOption('id_address') === 'new' && !!place){
                            // si on a une adresse en cours de création
                            //
                            view.selectPlace(place.id,cart.getDeliveryOption('description'));
                        }else if(!address && !view.ignoreAddressPreset){
                            // sinon on utilise l'adresse principale
                            address = app.getCustomer().getPrimaryAddress();
                        }else if(view.ignoreAddressPreset){
                            view.initialInput = '';
                        }
                        if(address){
                            view.initialAddress = address;
                        }
                    }
                }
                //
                if(view.initialAddress){
                    address = view.initialAddress;
                    var postcode = address.getPostcodeModel(), district = address.getDistrict();
                    view.selectAddress(address, postcode, district);
                    view.initialInput = address.formatAliasStreetAddress();
                }
                //
                if(view.initialStore){
                    // Todo, initial store
                    store = view.initialStore;
                    view.selectStore(store);
                    view.initialInput = store.getName();
                }
                //

                EstimatedTimeModel.resetAllDelays();
                //
                //PlaceModel.removeAllItems();
                PlaceModel.resetAllDelays();
                //

                if (_.isUndefined(arguments.el)) {
                    view.render();
                }

                if(view.ignoreInitialSelection){
                    // utile uniquement pour la vue "middle east"
                    // qui préselectionne le district, mais efface la selection
                    // on vide la valeur, mais on conserve le quartier
                    view.removeSelection();
                    view.setLocationVal('');
                }

                //
                //
                if (view.theme == 'modal' && view.mode != 'manual') {
                    if(app.isDesktop()){
                        view.on('focusIn', function(){
                            app.$htmlBody.stop(true,false).animate({ scrollTop: view.$('.main-title').offset().top - 10 }, 400);
                        });
                    }
                }

                // preload
                var autocompletePreload = app.get('autocompletePreload');
                if(autocompletePreload){
                    var val = autocompletePreload.value,
                        type = autocompletePreload.type,
                        focus = autocompletePreload.focus;
                    if(type==='store'){
                        view.updateType(type, true);
                    }
                    if(val){
                        view.setLocationVal(val);
                    }
                    if(focus){
                        setTimeout(function(){
                            view.autoFocus();
                        },100);
                    }
                }
                app.set('autocompletePreload',false);
                //
                hooks.execHook('AutocompleteFilterButtonExtensionView',{},function(AutocompleteFilterButtonExtensionView){
                    var buttonExtensionView = view.appendView(AutocompleteFilterButtonExtensionView,'.filter-button-extension',{});
                    buttonExtensionView.listenTo(view, 'updateType', buttonExtensionView.toggleComeInTooltip);
                });
                //
                view.listenTo(app,'geolocation',view.onGeolocate);
                view.listenTo(app,'geolocation_pending',view.onGeolocatePending);
                view.listenTo(app,'geolocation_error',view.onGeolocateError);
                view.listenTo(app,'toggleAddressAutocompleteType',view.toggleAddressAutocompleteType);
                view.autoGeolocate();

            },
            getInputLabels:function(type){
                var view = this,
                    title,placeholder,button,trContext = 'Stores', t = app.t;
                switch (type) {
                    // TODO : à traduire
                    case "store":
                        title = t('Rechercher une boutique', trContext);
                        placeholder = t('Entrez une ville, un quartier', trContext);
                        button = t('Rechercher', trContext);
                        break;
                    case "address":
                        if (view.action_context == 'add')
                        {
                            title = t('Entrez votre nouvelle adresse', trContext);
                            button = t('Enregistrez', trContext);
                        }else
                        {
                            title = t('Rechercher une adresse', trContext);
                            button = t('Rechercher', trContext);
                        }
                        placeholder = t('Entrez votre adresse', trContext);

                        break;
                    default :
                        title = t('Rechercher une adresse ou une boutique', trContext);
                        placeholder = t('Choisissez votre adresse de livraison ou votre boutique de retrait', trContext);
                        button = t('Commander', trContext);
                        break;
                }
                return {
                    title:title,
                    placeholder:placeholder,
                    button:button
                };

            },
            render: function () {
                var view = this,
                    type = view.type,
                    inputLabels = view.getInputLabels(type);
                //
                var template = view.theme == 'form-field' ? addressAutocompleteInputTemplate : addressAutocompleteTemplate,
                    viewOptions = _(view).pick(
                        'cid',
                        'type',
                        'action',
                        'theme',
                        'description',
                        'initialInput',
                        'title',
                        'displayFilters',
                        'displayDelay',
                        'style',
                        'fetchingPlace'
                    ),
                    inputLabelsOptions = _(inputLabels).pick(
                        'placeholder',
                        'title',
                        'button'
                    ),
                    options = _.extend(viewOptions,inputLabelsOptions, { hooks: hooks, view: view });

                view.$el.html(template(options));

                if (view.theme == 'form-field') {
                    view.attachViews(InputView.initializeInputsOfView(view));
                }


            },
            usePlaceFetch:function(){
                return this.fetchingPlace == 'yes';
            },
            toggleAddressAutocompleteType:function(newType){
              this.updateType(newType);
            },
            changeFilter:function(e){
                var currentTarget = e.currentTarget,
                    value = currentTarget.value;
                // tracking
                TagCommander.tc_ev_gl(currentTarget,'eventGA',{
                    click_level1:'Autocomplete Address',
                    click_level2:'change filter',
                    click_level3:value
                });

                this.updateType(value);
            },
            updateType:function(newType, ignoreFocus){
                var view = this,
                    addressAutocompleteEl = view.$('.address-autocomplete'),
                    inputLabels = view.getInputLabels(newType),
                    location = view.$('[name="location"]');
                //
                view.type = newType;
                delete view.input;
                _(['all','address','store']).each(function(t){
                    addressAutocompleteEl.toggleClass('type-'+t,newType==t);
                });
                view.$('.main-title').text(inputLabels.title);
                view.$('[name=filter]').val([newType]);
                view.$('.submit span').text(inputLabels.button);
                location.attr('placeholder',inputLabels.placeholder).val('');
                if (view.mode === 'manual' && !!view.selection && view.selection.getType() !== newType) {
                    view.removeSelection();
                }
                if(!ignoreFocus){
                    location.focus();
                    view.askRequest(true);
                    view.toggleResults(true);
                }
                view.autoGeolocate();
                view.trigger('updateType',newType);
            },
            selectAddress:function(address,postcode,district,data){
                var view = this,
                    options = {
                        type: 'address',
                        ignore_geo_validation: address.get('ignore_geo_validation'),
                        id_address: address.id,
                        action: view.action,
                        description:address.getAlias()
                };
                if(postcode){
                    options.id_postcode = postcode.id
                }
                if(data){
                    options.data = data;
                }
                if(district){
                    options.id_district = district.id_district;
                }
                view.selection = new AddressAutocompleteModel(options);
            },
            selectPlace:function(place_id,description){
                var view = this, options = {
                    type: 'address', place_id: place_id, action: view.action,
                    description:description
                };
                view.selection = new AddressAutocompleteModel(options);
            },
            selectStore:function(store){
                var view = this, options = {
                    type: 'store', id_store: store.id, action: view.action,
                    description:store.getName()
                };
                view.selection = new AddressAutocompleteModel(options);
            }, removeSelection: function () {
                var view = this;
                delete view.selection;
                view.selectedIndex = -1;
            },
            submitForm: function (e) {
                e.preventDefault();
                this.submitSelection();
            },
            submitFail:function(){
                // erreur générale (réseau, autre, etc)
                app.alert();
                this.toggleLoading(false);
            },
            autoFillFocus:function(){
                var input = this.getInput(),
                    isFocus = input.is(':focus');
                input.parent().toggleClass('input-filled',isFocus || input.val().length>0);
            },
            keyup: function (e) {
                var view = this;
                view.autoFillFocus();
                switch (e.keyCode) {
                    case 40 :
                    case 38 :
                        // up & down arrow keys
                        view.moveSelectedIndex(e.keyCode == 40 ? 1 : -1);
                        e.preventDefault();
                        e.stopPropagation();
                        break;
                    default:
                        view.askRequest(true);
                }
            },
            focusin: function (e) {
                var view = this, input = view.getInput().get(0);
                if(view.initialInput==view.getLocationVal()){
                    view.setLocationVal('');
                }
                input.setSelectionRange(0, view.getLocationVal().length);
                view.askRequest(false);
                view.toggleResults(true);
                view.trigger('focusIn');
                view.autoFillFocus();
            },
            autoFocus:function(){
                var view = this;
                view.$('[name=location]').focus();
                view.focusin();
            },
            focusout: function (e) {
                var view = this;
                // si on est pas sur les filtres ou sur le résultat
                if(view.$('.autocomplete-results:hover,.autocomplete-filters:hover').length>0) return;

                // si le champs est vide
                var selection = view.selection;
                if(selection && view.getLocationVal().length == 0 && !selection.isException()){
                    view.setLocationVal(selection.getLabel())
                }

                view.cancelRequest();
                view.toggleResults(false);
                view.autoFillFocus();
            },
            cancelRequest: function () {
                var view = this;
                if (view.collection) {
                    view.collection.cancel();
                    view.stopListening(view.collection);
                }
                delete view.collection;
            },
            toggleResults:function(visible){
                this.$('.autocomplete-results').toggleClass('visible',visible);
            },
            askRequest: function (cleanupSelection, forceRefresh) {
                var view = this,
                    input = view.getLocationVal(),
                    type = view.type,
                    mode = view.mode,
                    types = ['geocode'];
                //
                if (view.input === input && mode !== 'manual' && !forceRefresh){ // ignore identical query
                    return;
                }
                view.input = input;
                //

                 //efface les input sushishop
                input = input.replace(cleanSushishop, '');

                if (cleanupSelection) {
                    view.removeSelection();
                }

                //
                if (type === 'address') {
                    types = [type]
                }
                //

                view.cancelRequest();

                //view.listenTo(autocomplete, 'add', view.onAddAutocompleteModel);
                var options = {
                    displayDelay: view.displayDelay,
                    action: view.action,
                    action_context: view.action_context,
                    input: input,
                    types: types,
                    type: type, // address | store | all
                    mode: mode, // default | manual
                    componentRestrictions: {country: site_vars.country_code.toLowerCase()},
                    usePlaceFetch: view.usePlaceFetch(),
                    useGeolocation: app.hasGeolocation(),
                };

                var autocomplete = new AddressAutocompleteCollection();
                view.collection = autocomplete;
                view.listenTo(autocomplete, 'sync', view.getResults);
                view.listenToOnce(autocomplete, 'fallback', view.submitSelection);

                autocomplete.request(options);
            },
            cleanResults: function () {

                var view = this, resultView;
                view.selectedIndex = undefined;
                while (resultView = view.resultsView.pop()) {
                    view.detachView(resultView);
                }
                view.$('.autocomplete-results').attr('data-count','0');

            },
            getResults: function (autocompleteCollection) {
                //
                if (autocompleteCollection.name == 'AddressAutocompleteModel') {
                    return;
                }
                var view = this;
                if (autocompleteCollection != view.collection) {
                    return;
                }
                //

                if(view.mode == 'manual' && autocompleteCollection.size()==0 && autocompleteCollection.options.input == '' && !view.isFallbackVisible){
                    // si on est en mode manuel, et qu'on a aucun résultat, et pas d'input en saisie,
                    // on ouvre automatiquement la Modal de saisie manuelle
                    view.submitSelection();
                    return;
                }

                view.allResults = [];
                view.toggleResults(true);
                view.cleanResults(autocompleteCollection);

                if (autocompleteCollection.size() === 0) {
                    view.$('.results-title').removeClass('active');
                    view.$('.autocomplete-results').attr('data-count','0');
                    view.cleanResults();
                    return;
                }

                view.selectedIndex = autocompleteCollection.size()>0 ? 0 : -1;
                view.updateResults(autocompleteCollection);

                if(!view.getInput().is(':focus')){
                    view.focusout();
                }

            },
            updateResults:function(autocompleteCollection){
                //
                // ajoute ou met à jour un résultat, en fonction de l'ordre de tri, actualisé
                //
                var view = this,
                    countStores = autocompleteCollection.filterStores().length,
                    countAddresses = autocompleteCollection.filterAddresses().length,
                    addresses = 0,
                    stores = 0,
                    addressesDelay = 0, // affichage du titre des délais adresses
                    storesDelay = 0,   // affichage du titre des délais boutiques
                    lineCountMax = max(LINE_COUNT_MAX,autocompleteCollection.maxLines),
                    maxStores = min(countStores,max(LINE_STORE_ADDRESS_MEDIUM,lineCountMax-countAddresses)),
                    maxAddress = min(lineCountMax,min(countAddresses,lineCountMax-maxStores));
                view.maxIndex = maxStores+maxAddress;


                // gère l'ajout au DOM en une seule fois pour de mutliples vues
                view.autocompleteAddResult = new Array();
                view.autocompleteAddHtmlAddresses = '';
                view.autocompleteAddHtmlStores = '';

                autocompleteCollection.each(function (autocompleteModel,index) {

                    var validResult = true,
                        isStore = autocompleteModel.isStore(),
                        globalIndex;
                    if(isStore){
                        globalIndex = stores+maxAddress;
                        stores ++;
                        validResult = stores<=maxStores;
                        if(autocompleteCollection.displayDelay)
                            storesDelay += validResult ? ((autocompleteModel.isStoreOpened()) ? 1 : 0):0;
                    }else{
                        globalIndex = addresses;
                        addresses ++;
                        validResult = addresses<=maxAddress
                        if(autocompleteCollection.displayDelay)
                            addressesDelay += validResult ? (autocompleteModel.isStoreOpened() ? 1 : 0):0;
                    }
                    if(validResult){
                        view.addResult(autocompleteModel,globalIndex);
                    }else{
                        view.removeResult(autocompleteModel);
                    }
                });
                view.updateTitles(autocompleteCollection,storesDelay,addressesDelay);

            },
            moveSelectedIndex: function (direction) {
                var view = this;
                view.setSelectedIndex((view.selectedIndex+direction))
            },
            setSelectedIndex:function(index,isHover){
                // met à jour la ligne selectionné (survolée)
                //
                //
                var view = this,maxIndex = view.maxIndex;
                index = index >= maxIndex ? 0 : index < 0 ? maxIndex-1 : index;
                if(view.selectedLineView){
                    view.selectedLineView.$('.btn').toggleClass('active',false);
                }
                _(view.resultsView).each(function(lineView){
                    if(index == lineView.globalIndex){
                        view.selectedLineView = lineView;
                        lineView.$('.btn').toggleClass('active',index == lineView.globalIndex);
                    }
                });
                if(!isHover){
                    // index fort, lorsque le le survol disparait
                    view.strongIndex = index;
                }
                view.isHover = isHover;
                view.selectedIndex = index;
            },
            getDefaultSelectedModel:function(){
                var view = this,
                    selectedLineView = _(view.resultsView).findWhere({globalIndex:view.selectedIndex});
                if(selectedLineView) return selectedLineView.model;
            },
            updateTitles: function (collection,storesDelay,addressesDelay) {
                var view = this,
                    storesTitle = view.$('.stores .results-title'),
                    storesTitleDelay = storesTitle.find('.delays'),
                    addressesTitle = view.$('.addresses .results-title'),
                    addressesTitleDelay = addressesTitle.find('.delays'),
                    resultsEl = view.$('.autocomplete-results'),
                    activeClass = 'active',
                    hideClass = 'hide',
                    addresses = 0,
                    isEmpty = collection.options.input === '',
                    stores = 0;
                collection.each(function (model) {
                    switch (model.get('type')) {
                        case 'address':
                            addresses += isEmpty ? 1 : 0;
                            break;
                        case 'store':
                            stores++;
                            break;
                    }
                });
                resultsEl.attr('data-count',stores+addresses);
                storesTitle.toggleClass(activeClass, stores > 0);
                addressesTitle.toggleClass(activeClass, addresses > 0);
                storesTitleDelay.toggleClass(hideClass, storesDelay == 0);
                addressesTitleDelay.toggleClass(hideClass, addressesDelay == 0);
            },
            //onAddAutocompleteModel: function (autocompleteModel, collection, update) {
            //    var view = this;
            //    view.updateResults(collection);
            //},
            findResultsView:function(autocompleteModel){
                var view = this,
                    searchType = autocompleteModel.getType();
                return _(view.resultsView).find(function(lineView){
                    return lineView.model.isEqualTo(autocompleteModel, searchType);
                });
            },
            addResult: function (autocompleteModel,globalIndex) {
                var view = this,
                    autocompleteLineView = view.findResultsView(autocompleteModel),
                    isAddress = autocompleteModel.isAddress();
                //
                // 10 rue de la république
                //
                if(!autocompleteLineView){
                    var li = '<li id="line-'+autocompleteModel.cid +'" '+
                        'class="autocomplete-line '+(autocompleteModel.isValid()?'isValid':'')+' '+
                        (autocompleteModel.isFetching()?'fetching':'no-fetching')+'">';
                    li += addressAutocompleteLineTemplate(autocompleteModel);
                    li += '</li>';
                    if(isAddress){
                        view.autocompleteAddHtmlAddresses += li;
                    }else{
                        view.autocompleteAddHtmlStores += li;
                    }

                    view.autocompleteAddResult.push({
                       model:autocompleteModel,
                       globalIndex: globalIndex
                    });/*
                    autocompleteLineView = new AutocompleteLineView({model: autocompleteModel});
                    view.listenTo(autocompleteLineView,'hover',view.onHoverLine);
                    view.listenTo(autocompleteLineView, 'selectAutocompleteLine', view.selectAutocompleteLine);
                    view.attachView(autocompleteLineView);
                    view.resultsView.push(autocompleteLineView);
                    */
                }else{
                    view.autocompleteAddResult.push({
                       view:autocompleteLineView,
                       model:autocompleteModel,
                       globalIndex: globalIndex
                    });
                    //autocompleteLineView.globalIndex = globalIndex;
                }

                if(view.autocompleteAddResultRAF){
                    cancelAnimationFrame(view.autocompleteAddResultRAF);
                }
                view.autocompleteAddResultRAF = requestAnimationFrame($.proxy(view.initAddResult,view));

            },
            initAddResult:function(){
                //
                // executé après
                //
                var view = this,
                    $addressList = view.$('.addresses ul'),
                    $storeList = view.$('.stores ul');
                //
                $addressList.append(view.autocompleteAddHtmlAddresses);
                $storeList.append(view.autocompleteAddHtmlStores);
                delete view.autocompleteAddHtmlAddresses;
                delete view.autocompleteAddHtmlStores;
                //
                _(view.autocompleteAddResult).each(function(result){
                    var model = result.model,
                        lineView = result.view;
                    if(!lineView){
                        var lineEl = view.$('#line-'+model.cid);
                        lineView = new AutocompleteLineView({model: model,el:lineEl.get(0)});
                        lineView.globalIndex = result.globalIndex;
                        view.listenTo(lineView,'hover',view.onHoverLine);
                        view.listenTo(lineView, 'selectAutocompleteLine', view.selectAutocompleteLine);
                        view.attachView(lineView);
                        view.resultsView.push(lineView);
                    }
                });
                var childrenCount = $storeList.children().length + $addressList.children().length;
                view.$('.autocomplete-results').attr('data-count',childrenCount);
                view.setSelectedIndex(view.selectedIndex);

            },
            removeResult:function(autocompleteModel,globalIndex){
                var view = this,
                    resultsView = view.resultsView,
                    autocompleteLineView = _(resultsView).findWhere({model:autocompleteModel});
                if(autocompleteLineView){
                    var i = _(resultsView).indexOf(autocompleteLineView);
                    resultsView.splice(i,1);
                    view.detachView(autocompleteLineView);
                    return autocompleteLineView;
                }
            },
            onHoverLine:function(lineView,enter,e){
                var view = this;
                if(enter){
                    // mouseenter
                    view.setSelectedIndex(lineView.globalIndex,true);
                }else{
                    view.setSelectedIndex(view.strongIndex);
                }
            },
            getInput: function () {
                return this.$('[name=location]');
            },
            setLocationVal: function (val) {
                var input = this.getInput();
                input.parent().toggleClass('input-filled',val.length>0);
                return input.val(val);
            },
            getLocationVal: function () {
                return this.getInput().val();
            },
            selectAutocompleteLine: function (addressAutocompleteModel) {
                var view = this,
                    isException = addressAutocompleteModel.isException();
                //
                if(!isException){
                    view.setLocationVal(addressAutocompleteModel.getLabel());
                }
                view.$('.results-title').removeClass('active');
                view.selection = addressAutocompleteModel;
                //
                //
                if (view.autoSubmit || isException) {
                    view.submitSelection();
                }
                view.cleanResults();
                view.trigger('selectAutocompleteLine', addressAutocompleteModel);
                //}
            },
            //
            displayFallback: function (onSuccess, onFail, customerAddress) {
                var view = this;
                //
                if(view.isFallbackVisible) return;
                //
                TagCommander.tc_ev_gl(view.el,'pageview',{click_level1:'Adresse introuvable'})

                view.isFallbackVisible = true;
                var fallbackView = new AddressAutocompleteFallbackView({
                    address: view.getLocationVal(),
                    customerAddress: customerAddress,
                    action: view.action,
                    action_context: view.action_context,
                    cart: view.cart
                });

                function onFallbackAddress(address, postcode, district, data) {
                    onFallbackClose();
                    view.selectAddress(address, postcode, district, data);
                    if (_.isFunction(onSuccess)) {
                        onSuccess();
                    }
                }

                function onFallbackClickAndCollect(){
                    view.updateType('store',false);
                }

                function onFallbackFail() {
                    onFallbackClose();
                    delete view.selection;
                    if (_.isFunction(onFail)) {
                        onFail();
                    }
                }

                function onFallbackClose() {
                    view.isFallbackVisible = false;
                }

                view.listenToOnce(fallbackView, 'fallbackAddress', onFallbackAddress);
                view.listenToOnce(fallbackView, 'fallbackClickAndCollect', onFallbackClickAndCollect);
                view.listenToOnce(fallbackView, 'fallbackAddressFail', onFallbackFail);
                view.listenToOnce(fallbackView, 'close', onFallbackClose);
                app.displayModal(fallbackView);
            },

            validateSelection: function (options, onSuccess, onFail) {
                // before submit
                var view = this,
                    place,customerAddress,
                    addressAutocompleteModel = view.selection,
                    warningTitle = app.t('Attention', 'UI');
                //
                function displayFallback(){
                    // anonymous shortcut for "displayFallback"
                    view.displayFallback(onSuccess, onFail, customerAddress);
                }
                //
                if (_.isUndefined(addressAutocompleteModel)) {
                    // si il n'y a pas de sélection valide,
                    // on utilise le résultat par défaut
                    addressAutocompleteModel = view.getDefaultSelectedModel();
                }
                //
                if (_.isUndefined(addressAutocompleteModel)) {
                    // cas ou il n'y a pas de sélection valide (chaine vide)
                    if(view.type!=='store'){
                        displayFallback();
                    }else{
                        app.confirm({
                            title:warningTitle,
                            subtitle:app.t('Aucune boutique ne correspond à votre recherche. Voulez-vous consulter la liste de nos boutiques ?',TranslationContext),
                            validation:app.t('Consulter la liste',TranslationContext),
                        },function(confirm){
                            if(confirm){
                                if(view.theme === 'modal') view.trigger('close', view);
                                app.go('stores');
                            }
                        })
                    }
                    return false;
                }
                var validate = addressAutocompleteModel.validate();

                // errors
                function FetchedPlace(){
                    view.validateSelection(options, onSuccess, onFail);
                }

                switch(validate){
                    case 'NO_FETCHED_PLACE':
                        // fetch and resubmit
                        place = addressAutocompleteModel.getPlace();

                        place.once('sync',FetchedPlace);
                        place.fetch();
                        return false;
                    //
                    case 'INVALID_ADDRESS':
                        addressAutocompleteModel.getPlaceFromDescription(function(success){
                            if(success){
                                place = addressAutocompleteModel.getPlace();
                                view.listenToOnce(place,'sync',FetchedPlace);
                                place.fetch();
                            }else{
                                customerAddress = addressAutocompleteModel.getCustomerAddress();
                                displayFallback();
                            }
                        });
                        return false;
                    //
                    // lié au cas exceptionnel SSRST-266
                    //
                    case 'INVALID_ADDRESS_DISTRICT':
                        place = addressAutocompleteModel.getPlace();
                        customerAddress = addressAutocompleteModel.getCustomerAddress();
                        //
                        // TODO attention ce cas manque de gestion d'erreurs et d'exceptions.
                        // lié à des requêtes asynchrones
                        //
                        place.once('sync',function () {
                            var id_district = place.getDistrictId();
                            if(id_district && customerAddress){
                                customerAddress.set('id_district',id_district);
                                customerAddress.once('sync',function(){
                                    FetchedPlace();
                                });
                                customerAddress.save();
                                //
                            }else{
                                displayFallback();
                            }
                            //
                        });
                        place.once('error',displayFallback);
                        place.remoteFetch();
                        return false;
                    case 'NO_STREET_NUMBER':
                        var subtitle = 'Vous avez peut-être oublié le numéro de rue ?';
                        //
                        app.confirm({
                            title: warningTitle, subtitle: t(subtitle, TranslationContext),
                            validation:t("J’ai besoin d’aide",TranslationContext),
                            cancel:t('Annuler','UI')
                        },function(success){
                            if(success){
                                displayFallback();
                            }
                        });
                        return false;
                    case 'NO_STORE':
                        var subtitle = t('Cette adresse ne semble pas être déservie',TranslationContext);
                        //
                        addressAutocompleteModel.subscribePostcode();
                        app.trigger('openSubscribePostcodeView',addressAutocompleteModel,function(success){
                            if(success){
                                view.updateType('store',false);
                            }
                        });

                        /*
                        app.alert({
                            title: warningTitle,
                            subtitle: subtitle,
                            validation:t('Je vais en boutique',TranslationContext)
                        },function(){
                            view.updateType('store',false);
                        });
                         */
                        return false;
                    //
                    //
                    case 'UNKNOWN_LOCALITY' :
                        app.confirm({
                            title: warningTitle,
                            subtitle:t('Vous avez selectionné une adresse dans une nouvelle ville, confirmez-vous ce choix ?',TranslationContext),
                            validation:t('Oui','UI'),
                            cancel:t('Non','UI')
                        },function(success){
                            if(success){
                                addressAutocompleteModel.set('LOCALITY_USER_CHECKED',true);
                                onSuccess(addressAutocompleteModel);
                            }else{
                                displayFallback();
                            }
                        });
                        return false;
                    case 'EXCEPTION_FALLBACK':
                            displayFallback();
                        return false;
                    case 'OK': default:
                    break;
                }
                onSuccess(addressAutocompleteModel);
                return true;
            }, // submit current Selection
            // (as cart delivery option, as customer editing address)
            submitSelection: function (options, forceValidation) {

                var view = this, addressAutocompleteModel = view.selection,
                    cart = view.cart,
                    action = view.action;
                view.listenToOnce(addressAutocompleteModel,'error',view.submitFail);

                // tracking
                TagCommander.tc_ev_gl(view.el,'eventGA',{
                    click_level1:view.type === 'store' ? 'À emporter' : action === 'cart' ? 'En livraison' : 'Modification d’addresse',
                    click_level2:'OK',
                    click_level3:action
                });

                function onSuccess() {
                    // undefined > false > true

                    addressAutocompleteModel = view.selection;

                    if (_.isUndefined(addressAutocompleteModel)) {
                        // si il n'y a pas de sélection valide,
                        // on utilise le résultat par défaut
                        addressAutocompleteModel = view.getDefaultSelectedModel();
                    }

                    function Submit(){
                        view.toggleLoading(true);
                        switch (view.action) {
                            case 'cart' :
                                view.listenToOnce(cart, 'changeContext', view.onDeliveryUpdate);
                                view.listenToOnce(cart, 'setDeliveryOptionsFail', view.onSetDeliveryOptionsFail);
                                return addressAutocompleteModel.actionDeliveryOption(view.cart);
                            case 'edit' :
                            case 'invoice':
                                addressAutocompleteModel.once('afterSync',function(address){
                                    view.setLocationVal(addressAutocompleteModel.getLabel());
                                    view.trigger('success',address);
                                });
                                return addressAutocompleteModel.actionEditAddress(_.defaults({attach_to_cart:0,customer_primary:view.action_context==='default'},options));
                                break;
                        }
                    }

                    Submit();

                }

                function onFail() {
                    // TODO
                    // le fail n'est pas implémenté
                    var force = _.isUndefined(forceValidation) ? false : true;
                    view.submitSelection(options, force);
                }

                view.validateSelection(options, onSuccess, onFail);

            },
            _complete:false,
            isComplete:function(){
                return this._complete && this.cart.validateDeliveryOptions();
            },
            toggleLoading:function(state){
                var view = this;
                view.$('fieldset').attr('disabled',state);
                view.$('.submit').toggleClass('loading',state);
                view.$('.submit .circle-loader').toggleClass('playing',state);
            },
            onDeliveryUpdate: function () {
                var view = this;
                view.trigger('complete', view);
                view._complete = true;
                view.toggleLoading(false);
                if (view.theme == 'modal') {
                    view.trigger('close', view);
                }
            },
            onSetDeliveryOptionsFail: function (){
                this.toggleLoading(false);
            },
            clickClose: function () {
                this.trigger('close', this);
            },
            geolocate: function (ignore_error) {
                var view = this;
                view.toggleGeolocateButton(true);
                if(ignore_error!==true){
                    app.once('geolocation_error',alertGeolocateError);
                }
                app.requestGeolocation();
            },
            autoGeolocate: function(){
                var view = this;
                if(view.type === 'store'){
                    view.geolocate(true);
                }
            },
            toggleGeolocateButton:function(loading,error){
                var view = this, btn = view.$('.btn.geolocate');
                btn.attr('disabled',!!loading);
                btn.toggleClass('error',!!error);
                btn.find('i').toggleClass('playing',!!loading); // loader
                if(!view.getInput().is(document.activeElement)){
                    view.focusin();
                }
            },
            onGeolocatePending:function(){
                this.toggleGeolocateButton(true);
            },
            onGeolocateError:function(){
                this.toggleGeolocateButton(false,true);
            },
            onGeolocate:function(){
                var view = this;
                view.toggleGeolocateButton(false);
                app.off('geolocation_error',alertGeolocateError);
                if(view.type !== 'address'){
                    view.askRequest(false, true);
                }
            }
        });
    });

